module.exports = __webpack_public_path__ + "static/media/therapy_areas_resource36fe8d9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/therapy_areas_resource.svg
// module id = 1536
// module chunks = 0